import { useEffect } from "react";
import { useUnleashClient } from "@unleash/proxy-client-react";
import { useAppSelector } from "@/redux/hooks";

/**
 * Envia o GUID do usuário logado (userId) e a org ativa (loginId) no context do Unleash
 * e limpa no logout / sem org.
 */
export function useUnleashUserContext() {
  const client = useUnleashClient();
  const userId = useAppSelector((state) => state.authReducer.id);
  const loginId = useAppSelector((state) => state.generalReducer.LoginId);

  useEffect(() => {
    const id = String(userId ?? "").trim();
    if (!client) return;
    if (id) {
      void client.setContextField("userId", id);
      return;
    }
    void client.removeContextField("userId");
  }, [client, userId]);

  useEffect(() => {
    if (!client) return;
    const org = Number(loginId);
    if (Number.isInteger(org) && org > 0) {
      void client.setContextField("loginId", String(org));
      return;
    }
    void client.removeContextField("loginId");
  }, [client, loginId]);
}
